// extracted by mini-css-extract-plugin
module.exports = {"dot":"_497e51e0","activeDot":"_9a34ffec"};